import React, { useEffect } from "react";
import { TypeAnimation } from "react-type-animation";
import { useLocation } from "react-router-dom";
import "../styles/Home.css";

function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#projects-section") {
      // Delay ensures Projects component is fully rendered
      setTimeout(() => {
        const el = document.getElementById("projects-section");
        el?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);
  return (
    <div id="home">
      <div className="home-background">
        <div className="home-container">
          <TypeAnimation
            sequence={[
              "Hello, Im Yulia",
              1000,
              "Get to know me and my coding journey",
              1000,
            ]}
            wrapper="span"
            speed={50}
            style={{ fontSize: "2em", display: "inline-block" }}
            repeat={0}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
